import ExtraMenuItem from './ExtraMenuItem';

export default ExtraMenuItem;
